import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MarketoForm from '../../MarketoForm/MarketoForm';

const AIDecoded = ({ lazy }) => {
  const [submitted, setSubmitted] = useState(false);

  return (
    <div
      className={`newsletter__widget newsletter__widget__PluggedinFooter aiDecoded widget__state--${
        submitted ? 'submitted' : 'init'
      }`}
    >
      <header>
        <img
          alt="PluggedIn Newsletter logo"
          className="header__logo"
          src="https://assets.fastcompany.com/image/upload/v1705678917/aiDecoded_Logo_horizontal_outlined.svg"
          width={240}
          height={60}
        />
        {!submitted && (
          <div>
            <span className="highlight">
              A weekly newsletter that makes sense of the rapidly evolving world
              of generative AI
            </span>
          </div>
        )}
      </header>
      {submitted ? (
        <p className="submission success__message">
          <span className="text-primary">
            Thank you! Look out for your first email!
          </span>
        </p>
      ) : (
        <MarketoForm
          assetId={1595}
          name="inline-newsletter-form"
          onSubmitHandler={setSubmitted}
          lazy={lazy}
        />
      )}
      <footer>
        <a
          rel="noopener noreferrer"
          href="https://www.mansueto.com/privacy-policy/"
          target="_blank"
        >
          Privacy Policy
        </a>
      </footer>
    </div>
  );
};

AIDecoded.displayName = 'AIDecoded';

AIDecoded.propTypes = {
  lazy: PropTypes.bool
};

AIDecoded.defaultProps = {
  lazy: false
};

export default AIDecoded;
